module.exports = __webpack_public_path__ + "img/italic.66f22c06.svg";